import { render, staticRenderFns } from "./productAdd.vue?vue&type=template&id=16eada8d&scoped=true&"
import script from "./productAdd.vue?vue&type=script&lang=js&"
export * from "./productAdd.vue?vue&type=script&lang=js&"
import style0 from "./productAdd.vue?vue&type=style&index=0&id=16eada8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eada8d",
  null
  
)

export default component.exports